import state from '@/store/modules/auctions/defaultState';

const actions = {
  getMyAcvActiveSellingAuctions(
    {
      dispatch,
    },
    { page = 1 },
  ) {
    dispatch('getAuctionList', {
      subscribeAuctions: true,
      apiMethod: 'getMyAcvActiveSellingAuctions',
      moduleKey: 'MyAcvActiveSelling',
      numberOfLoaders: 3,
      page,
    });
  },
};

export default {
  state,
  actions,
};
